<template lang="pug">
.catalog-container
  img(src="./assets/catalogInit.svg")
  .description
    .label 您还未设置关键目录，快去设置吧~
    el-button(type="primary", size="small", @click="goto") 去设置
</template>

<script>
export default {
  name: "CatalogInit",
  methods: {
    goto() {
      this.$router.push({
        name: "directoryMaintenance",
        query: {
          forceJump: true
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.catalog-container {
  position: absolute;
  inset: 0;
  background-color: #fff;
  display: flex;
  flex-flow: nowrap row;
  justify-content: center;
  align-items: center;
  .label {
    font-size: 32px;
    color: #17233d;
    margin: 0 20px 20px 0;
  }
  .el-button {
    width: 88px;
  }
}
</style>
